import React from 'react';
import { COLORS, Color } from '../../styles/variables';

interface ArrowRightProps {
  color?: Color;
}

const ArrowRight: React.FC<ArrowRightProps> = ({ color = COLORS.black }) => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.12453 13.0793L11.2383 8.99703L7.12828 4.92078" stroke={color} />
    </svg>
  );
};

export default ArrowRight;
